import React from 'react'
import { Grid, Row, Panel, Table, Message } from 'rsuite'

export default function ProgressAssetView(props) {
  const { Column, HeaderCell, Cell } = Table

  const { schema } = props

  return (
    <div>
      <Row>
        <Panel bodyFill>
          <Grid fluid>
            {schema.message && <Message type="warning" description={schema.message} />}

            <Table
              isTree
              defaultExpandAllRows
              rowKey="id"
              cellBordered
              //height={400}
              autoHeight={schema?.projectAssets?.values?.length <= 7}
              wordWrap={true}
              //data={schema?.projectAssets?.values || []}
            >
              <Column width={500} flexGrow={1}>
                <HeaderCell>รายการ</HeaderCell>
                <Cell dataKey="name" />
              </Column>

              <Column width={100} align={'right'}>
                <HeaderCell>จำนวน</HeaderCell>
                <Cell dataKey="unit" />
              </Column>

              <Column width={100} align={'right'}>
                <HeaderCell>หน่วย</HeaderCell>
                <Cell dataKey="unitName" />
              </Column>
            </Table>
          </Grid>
        </Panel>
      </Row>
    </div>
  )
}
